import { createSlice } from '@reduxjs/toolkit'

export const modalConfirmation = createSlice({
  name: 'modalConfirmation',
  initialState: { open: false, continue: false },
  reducers: {
    setOpen: (state, action) => {
      state.open = action.payload
    },
    setContinue: (state, action) => {
      state.continue = action.payload
    },
  },
})

export const { setOpen, setContinue } = modalConfirmation.actions
export default modalConfirmation.reducer
